export const OPPORTUNITY_TYPES = ['new_website', 'website_improvement', 'unclassified', 'inconclusive'] as const;
export type OpportunityType = typeof OPPORTUNITY_TYPES[number];
export const OPPORTUNITY_LABELS: Record<OpportunityType, string> = {
    new_website: 'New Website', website_improvement: 'Website Improvement',
    unclassified: 'Unclassified', inconclusive: 'Inconclusive',
};
export const WEBSITE_EVIDENCE_LABELS = {
    not_found: 'No official website found', verified: 'Official website verified', inconclusive: 'Inconclusive',
} as const;
export const IMPROVEMENT_CATEGORIES = ['search_visibility', 'form_functionality', 'performance_mobile', 'design_modernization'] as const;
export const IMPROVEMENT_LABELS = {
    search_visibility: 'Search Visibility', form_functionality: 'Form Functionality',
    performance_mobile: 'Performance & Mobile Usability', design_modernization: 'Design Modernization',
} as const;
export const ENGINE_V2_POLICY = 'lead-engine-v2-p3';
